import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";

// thunk
export const fetchApprovedTemplates = createAsyncThunk(
  "whatsapp/fetchApprovedTemplates",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("api/whatsapp/approved-templates");
      
      return res.data.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message || "Something went wrong"
      );
    }
  }
);


const approvedTemplatesSlice = createSlice({
  name: "approvedTemplates",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearApprovedTemplatesError: (state) => {
      state.error = null;
    },
    resetApprovedTemplates: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApprovedTemplates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApprovedTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchApprovedTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch templates";
      });
  },
});

export const { clearApprovedTemplatesError, resetApprovedTemplates } =
  approvedTemplatesSlice.actions;

export default approvedTemplatesSlice.reducer;
